import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { AccessService } from 'app/access.service';
import { ApiService } from './api.service';
import { environment } from 'environments/environment';
import { finalize, map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  domain = environment.hostname;

  constructor(private router: Router, private accessService: AccessService, private apiService: ApiService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // let token = localStorage.getItem("token");
    // let userdetails = localStorage.getItem("data");
    // // let access_list = Object.values(JSON.parse(localStorage.getItem("accesslist") || '{}'));
    // let user = JSON.parse(userdetails || '{}');
    // const page = route.routeConfig?.path;
    // // console.log(user.role_id,"user.role_id")
    // // console.log(access_list,"access_list")
    // if (page !== "login") {
    //   // alert(1);
    //   if (!token) {

    //     const targetUrl = 'http://pramaat1.com/#/login';
    
    //     // Open the target window
    //     const targetWindow = window.open(targetUrl);
    //   }

    //   if (page) {
    //     console.log(user.role_id,"user.role_id")
    //     // console.log(access_list,"access_list")
    //     alert(page);
    //     if ((user.role_id === 1 || user.role_id === 2) ? true :true) {// this.accessService.checkaccess(page, "page", access_list)) {
    //       alert(page);
    //       return true;
    //     } else {
    //       alert('You do not have access to this page!');
    //       return false;
    //     }
    //   }
    // } else {
    //   alert(2);
    //   const targetUrl = 'http://pramaat1.com/#/login';
    
    // // Open the target window
    // const targetWindow = window.open(targetUrl);
    //   let data = { "domain": this.domain };

    //   return this.apiService.checkDomain(data).pipe(
    //     map((response) => {
    //       if (response.status_code === 404) {
    //         return this.router.parseUrl("/notfound");
    //       } else {
    //         return true;
    //       }
    //     }),
    //     catchError((error) => {
    //       console.error('Error fetching data:', error);
    //       return of(this.router.parseUrl("/notfound"));
    //     })
    //   );
    // }

    // // Default to allow navigation if no conditions match
    // return true;
    
   
    
    
    let token = localStorage.getItem("token")??'';
    // alert(token);
    if(token){
      const page = route.routeConfig?.path;
      // alert(1);
    let userdetails = localStorage.getItem("data");
    // let access_list = Object.values(JSON.parse(localStorage.getItem("accesslist") || '{}'));
    let user = JSON.parse(userdetails || '{}');

    if (page  && page !== "login") {
      
      console.log(user.role_id,"user.role_id")
      // console.log(access_list,"access_list")

      // if ((user.role_id === 1 || user.role_id === 2) ? true :true) {
        // this.accessService.checkaccess(page, "page", access_list)) {
        return true;
      // } else {
      //   alert('You do not have access to this page!');
      //   return false;
      // }
    
  } else {
  // Open the target window
    let data = { "domain": this.domain };

    return this.apiService.checkDomain(data).pipe(
      map((response) => {
        if (response.status_code === 404) {
          console.log("check4");
          window.location.href = `${environment.centralDomainUrl}/#/notfound`;
        } else {
          window.location.href = `${environment.centralDomainUrl}/#/login-dashboard`;
          return true;
        }
      }),
      catchError((error) => {
        console.error('Error fetching data:', error);
        return of(this.router.parseUrl("/notfound"));
      })
    );
  }
}


   
   
    // alert(page);
    // console.log(user.role_id,"user.role_id")
    // console.log(access_list,"access_list")
   

    // Default to allow navigation if no conditions match
    return true;
  }
}
